// DEPRECATED - because it was only used in ChargeCreateDialog in which it is written that component is deprecated
// It appears SalesPurchaseCharge took over (no idea why such a strange name)
import * as React from "react";
import Component from "../../AbstractComponent";
import ChargeClassContainer from "../../../Entity/Entities/Charge/ChargeClass/ChargeClassContainer";
import TypeContainer from "../../../Entity/Entities/Charge/Type/TypeContainer";
// import PersonLookup from "../Lookup/PersonLookup";
// import CompanyLookup from "../Lookup/CompanyLookup";
import Searchbar from "../Searchbar/Searchbar";
import { DatePickerComponent } from "../DatePicker/DatePickerComponent";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";
import { PropertyInterface } from "../../../Entity/Entities/Property/PropertyInterface";
import { UnitInterface } from "../../../Entity/Entities/Unit/UnitInterface";
import { ContractInterface } from "../../../Entity/Entities/Contract/ContractInterface";
import { PromptDialog } from "../Dialog/PromptDialog";
import { ChargeTypeCreate } from "../Dialog/ChargeTypeCreate";
import { Property } from "../../../Entity/Entities/Property/Property";
import { Unit } from "../../../Entity/Entities/Unit/Unit";
import { Contract } from "../../../Entity/Entities/Contract/Contract";
import { Company } from "../../../Entity/Entities/Company/Company";
import { Event } from "../../../Entity/Entities/Event/Event";
import Formatter from "../../../Localization/Formatter";
import Constants from "../../../Action/Constants";
import { BankAccountInterface } from "../../../Entity/Entities/BankAccount/BankAccountInterface";
// import Radio from '@material-ui/core/Radio';
// import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Select from "../../Partials/Material/Select";
import MenuItem from '@material-ui/core/MenuItem';
import TextField from "../../Partials/Material/TextField";
import Switch from '@material-ui/core/Switch';
import Time from "../../../Time/Time";
import Store from "../../../Store/Store";
import { PaymentInterface } from "../../../Entity/Entities/Payment/PaymentInterface";
import PaymentTypeContainer from "../../../Entity/Entities/Payment/PaymentType/PaymentTypeContainer";
import * as moment from "moment";
import  PaymentClassContainer from "../../../Entity/Entities/Payment/PaymentClass/PaymentClassContainer";
import { ChargeInterface } from "../../../Entity/Entities/Charge/ChargeInterface";
import { CoachNewCounterpartyDialog } from "../../Partials/Dialog/CoachNewCounterpartyDialog";

export default class Payment2DetailsEditable extends Component {
  public defaultChargeTypeLabel: string = this.props.defaultChargeTypeLabel || "Other_payable"
  public defaultChargeTypeId: string = this.props.defaultChargeTypeId || TypeContainer.pickIdFromLabel("Other_payable");

	public state = {
    amountForCharge: "",
    invoiceDateForCharge: new Date(),
    invoiceNumberForCharge: "",
    vatForCharge: "",
    vatPercentageForCharge: this.props.chargeCreateProcess ? this.props?.app?.settings?.agency?.vatPercentage : "",
    isInvoice: this.props.isInvoice,
    currencyIdForCharge: this.props.app?.settings?.user?.currency?.getCurrencyId(),
    showChargeOwnerChoice: true,
    chargeClassId: this.props.globalTypes?.ChargeType?.[this.defaultChargeTypeId]?.chargeClassId,
    chargeOwnerChoice: "person",
    typeIdForCharge: this.defaultChargeTypeId,
    typeIdForChargeManuallyChanged: false,
    descriptionForCharge: `${Formatter.checkTranslationType(this.trans(TypeContainer.pickLabelFromId(this.defaultChargeTypeId)), this.defaultChargeTypeLabel)}, ${this.formatter.monthFullFormatDate(new Date())}`,
    selectedEntityForCharge:  this.props.selectedEntity || null,
    selectedEntityForChargeManuallyChanged: false,
    selectedCounterpartyForCharge: this.props.selectedCounterpartyForCharge || null,
    periodForCharge: 3, // todo fix hardcoded value,
    firstDateForCharge: new Date(),
    dateOfPeriodForCharge: new Date(),
    descriptionForChargeIsManuallyChanged: false,
    isCreateChargeTypePopupOpen: false,
    renderChargeType: true,
    chargeTypeSelectField: null,
    isSettle: false,
    hasSettlementType: false,
    isLocked: false,
    isRemoved: false,
    isDisabled: false,
    charge: null,
    showInvoiceSwitch: true,
    hasSavingsType: false,
    openCoachCreateNewCounterparty: false
  };

  constructor(public props) {
    super(props);
  }

  public componentWillMount() {
    if (this.props.charge) {
      const charge: ChargeInterface = this.props.charge;
      const descriptionByTypeAndDate = `${Formatter.checkTranslationType(this.trans(charge?.type?.label, {}, "", charge?.type?.system), charge?.type?.label, charge?.type?.system)}, ${Formatter.monthFullFormatDate(charge.firstDate)}`.replace(/\s{2,}/g, ' ');

      let descriptionChargeDefault = charge.description.split(", ");
      let checkTypeDescription = Formatter.checkTranslationType(this.trans(charge?.type?.label, {}, "", charge?.type?.system), charge?.type?.label, charge?.type?.system) === descriptionChargeDefault[0]
      let checkMounthDescription = Formatter.monthFullFormatDate(charge.firstDate) === descriptionChargeDefault[1] || moment(charge.firstDate).format("MMM") === descriptionChargeDefault[1]
      let typeDescriptionPeriod = descriptionChargeDefault[1];

      const chargeClassId: number = charge?.chargeClass?.id;
      const isSettle = charge?.isSettle;
      const payments: PaymentInterface[] = [...charge.linkedPayments].filter((payment: PaymentInterface) => !!payment && !payment.removed);

      this.setState({
        charge: charge,
        // CASA-7824
        linkedToSavingsPayment: [...payments].some((payment: PaymentInterface) => payment?.paymentType?.id === PaymentTypeContainer.pickIdFromLabel("Savings_account")),
        descriptionForCharge: charge.description,
        amountForCharge: Formatter.simpleFormatNumber(charge.amount),
        invoiceDateForCharge: charge.invoiceDate,
        invoiceNumberForCharge: charge.invoiceNumber,
        vatForCharge: Formatter.simpleFormatNumber(charge.vat),
        vatPercentageForCharge: isNaN(Math.round(charge.vat / (charge.amount - charge.vat) * 100)) ? 0 : Formatter.simpleFormatNumber(Math.round(charge.vat / (charge.amount - charge.vat) * 100), false, false),
        isInvoice: charge.isInvoice,
        amazonFolderName: charge.amazonFolderName,
        attachments: charge.attachments,
        currencyIdForCharge: charge.currency.getCurrencyId(),
        typeIdForCharge: charge.type.id,
        firstDateForCharge: charge.firstDate,
        dateOfPeriodForCharge: charge.dateOfPeriod,
        periodForCharge: charge.period.id,
        openLeavePrompt: false,
        selectedEntityForCharge: charge.relatedEntity,
        selectedCounterpartyForCharge: charge?.counterparty,
        entityIsNotValid: false,
        isSaving: false,
        chargeOwnerChoice: charge.companyId ? "company" : "person",
        isPaymentUnlinkPopupOpen: false,
        isPaymentRemovePopupOpen: false,
        paymentToDelete: null,
        chargeTypeSelectField: null,
        anchorEl: null,
        chargeDescriptionAutomatic: ((charge.description === descriptionByTypeAndDate) || checkTypeDescription || checkMounthDescription) ? true : false,
        descriptionManuallyChanged: false,
        chargeTypeObj: charge.type,
        checkTypeDescriptionPeriod: (!checkMounthDescription && checkTypeDescription) ? true : false,
        typeDescriptionSecondParametr: typeDescriptionPeriod && typeDescriptionPeriod,
        isFetchingCharge: false,
        renderDetails: false,
        showChargeOwnerChoice: true,
        isSettle: isSettle,
        hasSettlementType: charge.hasSettlementType,
        chargeClassId: chargeClassId,
        financialStatement: charge.financialStatement,
        hasSavingsType: charge.hasSavingsType,
        note: charge.note,
        hasPayoutType: charge.hasPayoutType,
      });
    }

    if (this.props.payment) {
      const paymentClassId = this.props.payment?.paymentClass?.id;
      let typeIdForCharge: number;
      let chargeTypeLabel: string;

      if (paymentClassId == PaymentClassContainer.pickIdFromLabel("Payable")) {
        typeIdForCharge = TypeContainer.pickIdFromLabel("Other_payable");
        chargeTypeLabel = "Other_payable";
      } else {
        typeIdForCharge = TypeContainer.pickIdFromLabel("Other_receivable");
        chargeTypeLabel = "Other_receivable";
      }

      let descriptionForCharge;
      
      if (this.props.payment?.description) {
        descriptionForCharge = this.props.payment?.description;
      } else {
        descriptionForCharge = `${Formatter.checkTranslationType(this.trans(TypeContainer.pickLabelFromId(typeIdForCharge)), chargeTypeLabel)}, ${this.formatter.monthFullFormatDate(this.props.payment?.firstDateOfStatementPeriod)}`;
      }

      const vatPercentageNumber: any = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.props?.app?.settings?.agency?.vatPercentage)).replace(",", ".")).toFixed(2));

      this.setState({
        chargeClassId: String(paymentClassId),
        amountForCharge: Formatter.simpleFormatNumber(this.props.payment?.amountRemaining),
        vatForCharge: vatPercentageNumber ? Formatter.simpleFormatNumber(this.props.payment?.amountRemaining / (100 + vatPercentageNumber) * vatPercentageNumber) : "",
        invoiceDateForCharge: this.props.payment?.dateOfThePayment,
        dueDateForCharge: this.props.payment?.dateOfThePayment,
        currencyIdForCharge: this.props.payment?.currency.getCurrencyId(),
        typeIdForCharge: typeIdForCharge,
        firstDateForCharge: this.props.payment?.dateOfThePayment,
        dateOfPeriodForCharge: this.props.payment?.dateOfThePayment,
        selectedEntityForNewCharge: null,
        selectedCounterpartyForNewCharge: this.props.payment?.counterparty,
        descriptionForCharge: descriptionForCharge
      }, () => this.fetchChargeDetails(this.props.payment));
    }
	}

  public updateParentState = (callback?) => {
    if (typeof this.props.updateState === "function") {
      this.props.updateState.call(this, {...this.state}, callback);
    }
  }

  // we should fetch details for charge(type and object) if user enters amount and selected person/company
  public fetchChargeDetails = (currentPayment: PaymentInterface): void => {
    if (!!currentPayment) {
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_DETAILS_FROM_LAST_SIMILAR_PAYMENT,
        payload: {
          paymentId: currentPayment?.id
        },
        onSuccess: details => {
          let entity: any;
          let counterparty: any;
          let chargeTypeId: number = details?.typeId;

          if (details?.contactId) {
            counterparty = this.props.app.persons.find(person => person.id === details.contactId);
          }

          if (details?.companyId) {
            counterparty = this.props.app.companies.find(company => company.id === details.companyId);
          }

          if (counterparty) {
            this.setState({
              selectedCounterpartyForCharge: counterparty,
            });
          }

          if (details?.ownerId) {
            entity = this.props.app.companies.find(company => company.id === details.ownerId);
          }

          if (details?.contractId) {
            entity = this.props.app.contracts.find(contract => contract.id === details.contractId);
          }

          if (details?.unitId) {
            entity = this.props.units.byId[details.unitId];
          }

          if (details?.propertyId) {
            entity = this.props.properties.byId[details.propertyId];
          }

          if (entity && !this.state.selectedEntityForChargeManuallyChanged) {
            this.setState({
              selectedEntityForNewCharge: entity,
            }, this.getStatementPeriodForCharge);
          }

          if (chargeTypeId && !this.state.typeIdForChargeManuallyChanged) {
            const type = this.getChargeTypeBySelect(chargeTypeId);
            const typeName = this.formatter.checkTranslationType(this.trans(type?.label, {}, "", type?.system), type.label, type?.system);
            this.setState({
              typeIdForCharge: chargeTypeId
            });
            this.setDescriptionEqualToType(typeName, this.formatter.monthFullFormatDate(this.state.firstDateForCharge));
          }
        }
      })
    }
  }

  public selectDate = (date: Date, identifier: string): void => {
    let selectedDate = date;

    if (date) {
      if ((identifier === "dateOfPeriodForCharge") ||
         (identifier === "firstDateForCharge" && this.state.periodForCharge === 3)) {  // todo fix hardcoded value
        selectedDate = Time.firstDateSelectedMonth(date);
      }
    }

    this.setState({
      [identifier]: selectedDate,
      hasModifiedData: true
    }, () => {
      if (identifier === "dateOfPeriodForCharge" && this.props.chargeCreateProcess) {
        let typeName;

        if (!!this.state.typeIdForCharge) {
          const type = this.getChargeTypeBySelect(this.state.typeIdForCharge);
          typeName = Formatter.checkTranslationType(this.trans(type?.label, {}, "", type?.system), type?.label, type?.system);
        }

        this.setDescriptionEqualToType(typeName, Formatter.monthFullFormatDate(date));
      }
    });
  }

  public setDescriptionEqualToType(typeName: string, date: string) {
    if (!this.state.descriptionForChargeIsManuallyChanged) {
      if (!!typeName) {
        this.setState({
          descriptionForCharge: typeName + ", " + date
        });
      } else {
        this.setState({
          descriptionForCharge: date
        });
      }
    }
  }

  public getChargeTypeBySelect = (id) => {
    const chargeType = Store.getConfigurator().getState().globalTypes?.ChargeType;

    if (!!id) {
      for (const key in chargeType) {
        if (chargeType[key].id === id) {
          return chargeType[key];
        }
      }
    }
  }

	public changeAmountForCharge = (event): void => {
    let amount: string = event.target.value;
    amount = this.formatter.formatSigns(amount);

    if (this.state.vatPercentageForCharge) {
      let amountForCharge: number = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(amount)).replace(",", ".")).toFixed(2));
      amountForCharge = isNaN(amountForCharge) ? 0 : amountForCharge;

      let vatPercentageNumber: any = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.vatPercentageForCharge)).replace(",", ".")).toFixed(2));
      vatPercentageNumber = isNaN(vatPercentageNumber) ? 0 : vatPercentageNumber;

      const vatNumber = amountForCharge / (100 + vatPercentageNumber) * vatPercentageNumber;
      
      return this.setState({
        vatForCharge: this.formatter.simpleFormatNumber(Math.round(vatNumber * 100 + Number.EPSILON) / 100, false),
        amountForCharge: amount,
        hasModifiedData: true
      });
    }

    if (this.state.vatForCharge) {
      let vat: string = this.state.vatForCharge;
      vat = this.formatter.formatSigns(vat);

      let amountForCharge: number = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(amount)).replace(",", ".")).toFixed(2));
      amountForCharge = isNaN(amountForCharge) ? 0 : amountForCharge;

      let vatNumber: any = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(vat)).replace(",", ".")).toFixed(2));
      vatNumber = isNaN(vatNumber) ? 0 : vatNumber;

      const vatPercentageNumber = vatNumber / (amountForCharge - vatNumber) * 100;

      return this.setState({
        vatPercentageForCharge: isNaN(vatPercentageNumber) ? 0 : this.formatter.simpleFormatNumber(Math.round(vatPercentageNumber), false, false),
        amountForCharge: amount,
        hasModifiedData: true
      });
    }

    return this.setState({
      vatForCharge: "",
      vatPercentageForCharge: "",
      amountForCharge: amount,
      hasModifiedData: true
    });
  }

  public changeInvoiceNumberForCharge = (event): void => {
    const invoiceNumber: string = event.target.value;

    this.setState({
      invoiceNumberForCharge: invoiceNumber,
      hasModifiedData: true,
    });
  }

  public changeVatForCharge = (event): void => {
    let vat: string = event.target.value;
    vat = this.formatter.formatSigns(vat);

    let amountForCharge: number = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.amountForCharge)).replace(",", ".")).toFixed(2));
    amountForCharge = isNaN(amountForCharge) ? 0 : amountForCharge;

    let vatNumber: any = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(vat)).replace(",", ".")).toFixed(2));
    vatNumber = isNaN(vatNumber) ? 0 : vatNumber;

    const vatPercentageNumber = vatNumber / (amountForCharge - vatNumber) * 100;

    this.setState({
      vatForCharge: vat,
      vatPercentageForCharge: isNaN(vatPercentageNumber) ? 0 : this.formatter.simpleFormatNumber(Math.round(vatPercentageNumber), false, false),
      hasModifiedData: true
    });
  }

  public changeVatPercentageForCharge = (event): void => {
    let vatPercentage: string = event.target.value;
    vatPercentage = this.formatter.formatSigns(vatPercentage);

    let amountForCharge: number = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.amountForCharge)).replace(",", ".")).toFixed(2));
    amountForCharge = isNaN(amountForCharge) ? 0 : amountForCharge;

    let vatPercentageNumber: any = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(vatPercentage)).replace(",", ".")).toFixed(2));
    vatPercentageNumber = isNaN(vatPercentageNumber) ? 0 : vatPercentageNumber;

    const vatNumber = amountForCharge / (100 + vatPercentageNumber) * vatPercentageNumber;

    this.setState({
      vatForCharge: this.formatter.simpleFormatNumber(Math.round(vatNumber * 100 + Number.EPSILON) / 100, false),
      vatPercentageForCharge: vatPercentage,
      hasModifiedData: true
    });
  }

  public changeCurrencyIdForCharge = (event): void => {
    let currency: number = event.target.value;

    this.setState({
      currencyIdForCharge: currency,
      hasModifiedData: true
    });
  }

  public changeTypeIdForCharge = (...args: any[]): void => {
    if (!!args[1].props.value) {
      const type = this.getChargeTypeBySelect(args[1].props.value);
      const typeName = Formatter.checkTranslationType(this.trans(type?.label, {}, "", type?.system), type?.label, type?.system);
      const chargeClassId: number = this.props.globalTypes?.ChargeType?.[type?.id]?.chargeClassId;

      this.setState({
        typeIdForCharge: type.id,
        typeIdForChargeManuallyChanged: true,
        hasModifiedData: true,
        chargeClassId: chargeClassId,
        showChargeOwnerChoice: true
      }, () => this.setState({renderChargeType: false}, () => {
        this.setState({renderChargeType: true});
      }));

      this.setDescriptionEqualToType(typeName, this.formatter.monthFullFormatDate(this.state.firstDateForCharge));
    }
  }

  public getStatementPeriodForCharge = () => {
    if (
      this.state.charge.type.id ===
        TypeContainer.pickIdFromLabel('Overpaid_payable') ||
      this.state.charge.type.id ===
        TypeContainer.pickIdFromLabel('Overpaid_receivable')
    ) {
      return;
    }

    const payload: any = {
      statementPeriod: Time.formatOrNull(this.state.firstDateForCharge)
    };

    if (this.state.selectedEntityForCharge instanceof Property) {
      payload.propertyId = this.state.selectedEntityForCharge.id;
    }

    if (this.state.selectedEntityForCharge instanceof Unit) {
      payload.unitId = this.state.selectedEntityForCharge.id;
    }

    if (this.state.selectedEntityForCharge instanceof Contract) {
      payload.contractId = this.state.selectedEntityForCharge.id;
    }

    if (this.state.selectedEntityForCharge instanceof Company) {
      payload.ownerId = this.state.selectedEntityForCharge.id;
    }

    if (this.state.selectedEntityForCharge instanceof Event) {
      payload.eventId = this.state.selectedEntityForCharge.id;
    }

    return this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_PERIOD,
      payload: {
        ...payload
      },
      onSuccess: (data) => {
        if (data?.statementPeriod) {
          this.selectDate(new Date(data?.statementPeriod), "firstDateForCharge");
        }
      }
    })
  }

  public selectEntityForCharge = (entity: PropertyInterface | UnitInterface | ContractInterface): void => {
    this.setState({
      selectedEntityForCharge: entity,
      selectedEntityForChargeManuallyChanged: true,
      hasModifiedData: true
    }, this.getStatementPeriodForCharge);
  }

  public clearEntityForCharge = (): void => {
    this.setState({
      selectedEntityForCharge: null,
      hasModifiedData: true
    });
  }

  public selectCounterpartyForCharge = (entity: CompanyInterface | PersonInterface): void => {
    this.setState({
      selectedCounterpartyForCharge: entity,
      hasModifiedData: true
    });
  }

  public clearCounterpartyForCharge = (): void => {
    this.setState({
      selectedCounterpartyForCharge: null,
      hasModifiedData: true
    });
  }

  public changeDescriptionForCharge = (event): void => {
    const description: string = event.target.value;

    this.setState({
      descriptionForCharge: description,
      hasModifiedData: true,
      descriptionForChargeIsManuallyChanged: true
    });
  }

  public addChargeType = (chargeType: object, callback?): void => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_TYPE_CREATE_START,
        payload: {
          chargeType: chargeType
        },
        onSuccess: (chargeType) => {
          this.setState({
            isSaving: false,
            typeIdForCharge: chargeType.id,
            isCreateChargeTypePopupOpen: false,
            hasModifiedData: true
          });

          this.setDescriptionEqualToType(chargeType.label, this.formatter.monthFullFormatDate(this.state.firstDateForCharge));

          if (typeof callback === "function") {
            this.setState({
              isCreateChargeTypePopupOpen: false,
              // we need this hack to rerender type select to have correct presentation
              renderChargeType: false
            }, () => this.setState({renderChargeType: true}));
          }
        },
        onError: () => {
          this.setState({
            hasModifiedData: true,
            isSaving: false
          });
        }
      });
    });
  }

  public closeChargeTypeCreateDialog = (): void => {
    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TYPE_CREATE_CLEAR,
    });

		this.setState({isCreateChargeTypePopupOpen: false});
  }

  public changeClassIdForCharge = (event): void => {
    let chargeClassId: number = event.target.value;

    this.setState({
      chargeClassId: String(chargeClassId)
    }, () => {
      // when we change class we should automatically change type
      const typeId: number = Number(this.state.chargeClassId) == ChargeClassContainer.pickIdFromLabel("Payable") ? 
                             TypeContainer.pickIdFromLabel("Other_payable") :
                             TypeContainer.pickIdFromLabel("Other_receivable");
      this.changeTypeIdForCharge(null, {props: {value: typeId}})                       
    });
  }

  public handleChangeIsInvoice = (event) => {
    this.setState({
      isInvoice: event.target.checked
    })
  }

  public renderCounterpartyField = (classId) => {
    return (
      <div className="search-bar-container" style={{/*margin: "-20px 0 -10px 0"*/}}>
        <Searchbar
          {...this.props}
          id="selectedCounterpartyForCharge"
          className={"scroll-to-counterpartyId"}
          // floatingLabelText={labelText}
          floatingLabelText={Number(classId) == ChargeClassContainer.pickIdFromLabel("Receivable") ? this.trans("section/charge-field/from-label") : this.trans("section/charge-field/to-label")}
          allResults={true}
          objectField={true}
          onChange={this.selectCounterpartyForCharge}
          onClear={this.clearCounterpartyForCharge}
          selectedEntity={this.state.selectedCounterpartyForCharge}
          searchParameter={"contactsSearch"}
          error={this.getErrorFor("counterpartyId")}
          disabled={this.state.isDisabled}
          showClickThroughLink={!this.props.dialogPresentation}
          searchText={this.state.selectedCounterpartyForCharge ? `${this.state.selectedCounterpartyForCharge.nameOfEntity}, ${this.state.selectedCounterpartyForCharge.displayName}` : null}
          styleInModal={"pick-object-modal"}
          createButton={"dropdown-button/newcounterparty"}
          openCoachCreateNewEntity={() => {
            this.setState({
              openCoachCreateNewCounterparty: true,
              selectedCounterparty: null
            })}
          }
        />
      </div>
    );
  }

  public renderBankAccountField = (classId) => {
    const agencyBankAccount = this.getAgencyBankAccounts().find((bankAccount: BankAccountInterface) => bankAccount?.isDefault);
    
    return (
      <Select
        className="form-element form-input scroll-to-bank-account correct-label-position"
        error={this.getErrorFor("bank-account")}
        style={{width: "100%"}}
        disabled={true}
        value={agencyBankAccount?.id}
        htmlFor="bankAccount"
        label={Number(classId) == ChargeClassContainer.pickIdFromLabel("Receivable") ? this.trans("section/charge-field/to-label") : this.trans("section/charge-field/from-label")}
        name="bankAccount" 
        id="bankAccount"
      >
        <MenuItem
          key={`bankAccount-${agencyBankAccount?.id}`}
          value={agencyBankAccount?.id}
          className="filter-payment-item table-bankaccount-dropdown"
        >
        <div className="bank-account-menuitem-wrapper" style={{height: "14px"}}>
          <div>{`${agencyBankAccount?.accountId ? `${agencyBankAccount?.accountId} - ` : ""} ${agencyBankAccount?.name !== "" && agencyBankAccount?.name ? `${agencyBankAccount?.name}` : ""}`}</div>
        </div>
        </MenuItem>
      </Select>
    );
  }

  public renderCharge = (classId, _labelText) => {
    return (
      <div style={{display: "flex", justifyContent: "flex-start"}}>
        <div>
          <div style={{width: "420px", display: "flex", justifyContent: "flex-start", alignItems: "flex-start"}}>
            <Select
              className="form-element form-input scroll-to-chargeClassId correct-label-position"
              error={this.getErrorFor("chargeClassId")}
              style={{width: "30%", marginRight: "10px"}}
              disabled={this.state.isDisabled || this.props.payment}
              value={Number(classId)}
              onChange={this.changeClassIdForCharge}
              htmlFor="chargeClassId"
              label={this.trans("section/charge-field/class-label")}
              name="chargeClassId" 
              id="chargeClassId"
            >
              <MenuItem
                key={`chargeClassId-${ChargeClassContainer.pickIdFromLabel("Receivable")}`}
                value={ChargeClassContainer.pickIdFromLabel("Receivable")}
              >
                {this.trans("section/charge-field/classreceivable-label")}
              </MenuItem>
              <MenuItem
                key={`chargeClassId-${ChargeClassContainer.pickIdFromLabel("Payable")}`}
                value={ChargeClassContainer.pickIdFromLabel("Payable")}
              >
                {this.trans("section/charge-field/classpayable-label")}
              </MenuItem>
            </Select>
            <div style={{fontStyle: "italic", marginTop: "20px"}}>
              {Number(classId) == ChargeClassContainer.pickIdFromLabel("Receivable") ? this.trans("section/charge-field/classreceivableexplanation-label", {agencyName: this.getAgency().name}) : this.trans("section/charge-field/classpayableexplanation-label", {agencyName: this.getAgency().name})}
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "420px",
            }}
          >
            <div style={{display: "flex", flexDirection: "column", width: "70%", marginRight: "10px"}}>
              <TextField
                autoComplete="off"
                //id="amountForCharge"
                className="form-element full-size scroll-to-amountForCharge"
                type="text"
                label={this.trans("section/charge-field/аmount-label")}
                value={this.state.amountForCharge}
                onChange={this.changeAmountForCharge}
                variant="standard"
                disabled={this.state.isDisabled}
                autoFocus={!!this.props.autoFocusAmount}
                error={!!this.getErrorFor("amountForCharge")}
                helperText={this.getErrorFor("amountForCharge")}
              />
            </div>

            <Select
              className="form-element form-input scroll-to-currencyIdForCharge correct-label-position"
              style={{width: "30%"}}
              error={this.getErrorFor("currencyIdForCharge")}
              value={this.state.currencyIdForCharge}
              onChange={this.changeCurrencyIdForCharge}
              htmlFor="currencyIdForCharge"
              // label={{this.trans("section/charge-field/currency-label")}}
              name="currencyIdForCharge" 
              id="currencyIdForCharge"
              disabled={this.state.isDisabled}
            >
              {this.getCurrencySelectboxes()}
            </Select>
          </div>

          {Number(classId) == ChargeClassContainer.pickIdFromLabel("Receivable") && (
            <div style={{width: "420px"}}>
              <div style={{/*margin: "15px 0 0 0"*/}}>
                {!!this.state.showChargeOwnerChoice && this.renderCounterpartyField(classId)}
              </div>
              <div style={{/*margin: "-20px 0 0 0"*/}}>
                {this.renderBankAccountField(classId)}
              </div>
            </div>
          )}
          
          {Number(classId) == ChargeClassContainer.pickIdFromLabel("Payable") && (
            <div style={{width: "420px"}}>
              <div style={{margin: "-5px 0 0px 0"}}>
                {this.renderBankAccountField(classId)}
              </div>
              {!!this.state.showChargeOwnerChoice && this.renderCounterpartyField(classId)}
            </div>
          )}

          <div className="search-bar-container" style={{margin: "50px 0 10px 0"}}>
            <Searchbar
              {...this.props}
              id="selectedEntityForCharge"
              className={"scroll-to-objectId"}
              // floatingLabelText={labelText}
              floatingLabelText={this.trans("section/charge-field/for-label")}
              allResults={true}
              objectField={true}
              onChange={this.selectEntityForCharge}
              onClear={this.clearEntityForCharge}
              selectedEntity={this.state.selectedEntityForCharge}
              searchParameter={"objectForChargeSearch"}
              error={this.getErrorFor("objectId")}
              disabled={this.state.isDisabled}
              showClickThroughLink={!this.props.dialogPresentation}
              searchText={this.state.selectedEntityForCharge ? `${this.state.selectedEntityForCharge.nameOfEntity}, ${this.state.selectedEntityForCharge.displayName}` : null}
              styleInModal={"pick-object-modal"}
            />
            <div className="hint-styles-dialog">
              {this.trans("section/charge-for-hint")}
            </div>
          </div>

          <div style={{width: "420px"}}>
            {this.state.renderChargeType === TypeContainer.pickIdFromLabel("Settlement") && (
              <Select
                className="form-element full-size form-input scroll-to-typeIdForCharge correct-label-position"
                error={this.getErrorFor("typeIdForCharge")}
                disabled={this.state.isDisabled}
                style={{marginRight: "15px"}}
                value={this.state.typeIdForCharge}
                onChange={this.changeTypeIdForCharge}
                htmlFor="type"
                label={this.trans("section/charge-field/type-label")}
                name="type" 
                id="type"
              >
                {
                  TypeContainer.getSettlementType().map((type,index) => {
                    return (
                      <MenuItem key={index} value={type.id}>{`${Formatter.checkTranslationType(this.trans(type?.label, {}, "", type?.system), type?.label, type?.system)}`}</MenuItem>
                    );
                  })
                }
              </Select>
            )}

            {this.state.renderChargeType === TypeContainer.pickIdFromLabel("Payout_receivable") && (
              <Select
                className="form-element full-size form-input scroll-to-typeIdForCharge correct-label-position"
                error={this.getErrorFor("typeIdForCharge")}
                disabled={this.state.isDisabled}
                style={{marginRight: "15px"}}
                value={this.state.typeIdForCharge}
                onChange={this.changeTypeIdForCharge}
                htmlFor="type"
                label={this.trans("section/charge-field/type-label")}
                name="type" 
                id="type"
              >
                {
                  TypeContainer.getPayoutReceivableType().map((type,index) => {
                    return (
                      <MenuItem key={index} value={type.id}>{`${Formatter.checkTranslationType(this.trans(type?.label, {}, "", type?.system), type?.label, type?.system)}`}</MenuItem>
                    );
                  })
                }
              </Select>
            )}

            {this.state.renderChargeType === TypeContainer.pickIdFromLabel("Payout_payable") && (
              <Select
                className="form-element full-size form-input scroll-to-typeIdForCharge correct-label-position"
                error={this.getErrorFor("typeIdForCharge")}
                disabled={this.state.isDisabled}
                style={{marginRight: "15px"}}
                value={this.state.typeIdForCharge}
                onChange={this.changeTypeIdForCharge}
                htmlFor="type"
                label={this.trans("section/charge-field/type-label")}
                name="type" 
                id="type"
              >
                {
                  TypeContainer.getPayoutPayableType().map((type,index) => {
                    return (
                      <MenuItem key={index} value={type.id}>{`${Formatter.checkTranslationType(this.trans(type?.label, {}, "", type?.system), type?.label, type?.system)}`}</MenuItem>
                    );
                  })
                }
              </Select>
            )}

            {
              this.state.renderChargeType !== TypeContainer.pickIdFromLabel("Settlement") &&
              this.state.renderChargeType !== TypeContainer.pickIdFromLabel("Payout_receivable") &&
              this.state.renderChargeType !== TypeContainer.pickIdFromLabel("Payout_payable") && (
                <Select
                  className="form-element full-size form-input scroll-to-typeIdForCharge correct-label-position"
                  error={this.getErrorFor("typeIdForCharge")}
                  variant="standard"
                  value={this.state.typeIdForCharge}
                  onChange={this.changeTypeIdForCharge}
                  htmlFor="type"
                  label={this.trans("section/charge-field/type-label")}
                  name="type" 
                  id="type"
                  disabled={this.state.isDisabled}
                >
                  {
                    TypeContainer.getChargeTypes(Number(classId) == ChargeClassContainer.pickIdFromLabel("Payable") ? "payable" : "receivable")
                    .filter(chargeType => {
                      if((TypeContainer.pickIdFromLabel("Savings_account_withdraw") === chargeType.id || TypeContainer.pickIdFromLabel("Savings_account_deposit") === chargeType.id)  &&  (this.state.renderChargeType !== TypeContainer.pickIdFromLabel("Savings_account_withdraw") && this.state.renderChargeType !== TypeContainer.pickIdFromLabel("Savings_account_deposit"))) {
                        return false;
                      }

                      if((TypeContainer.pickIdFromLabel("Stub_receivable") === chargeType.id || TypeContainer.pickIdFromLabel("Stub_payable") === chargeType.id)  &&  (this.state.renderChargeType !== TypeContainer.pickIdFromLabel("Stub_receivable") && this.state.renderChargeType !== TypeContainer.pickIdFromLabel("Stub_payable"))) {
                        return false;
                      }

                      if (!!this.state.typeIdForCharge && chargeType.removed && (chargeType.id === this.state.typeIdForCharge)) {
                        return true;
                      }

                      if (chargeType.removed) {
                        return false;
                      }

                      return true;
                    })
                    .map((type, index) => {
                      return (
                        <MenuItem key={`chargeType-${index}`} value={type.id} disabled={(type.id === -1 || type.id === -2)}>{`${type.id === -1 || type.id === -2 ? type.label : Formatter.checkTranslationType(this.trans(type?.label, {}, "", type?.system), type?.label, type?.system)}`}</MenuItem>
                      );
                    })
                  }
                  {
                    (TypeContainer.pickIdFromLabel("Credit_receivable") === this.state.charge?.type?.id || TypeContainer.pickIdFromLabel("Credit_payable") === this.state.charge?.type?.id) && <MenuItem key={`chargeType-${this.state.charge?.type?.id}`} value={this.state.charge?.type?.id}>{this.trans(`${TypeContainer.pickIdFromLabel("Credit_payable") === this.state.charge?.type?.id ? "credit_payable": "credit_receivable"}`)}</MenuItem>
                  }
                  {/*  <MenuItem
                    className="add-charge-type-div button-add-wrapper"
                  >
                    <Button
                      style={{width: "100%"}}
                      className="add-charge-type-button color-button-add"
                      color="primary"
                      onClick={() => this.setState({isCreateChargeTypePopupOpen: true})}
                    >
                      {this.trans("dropdown/chargetype-button/newchargetype")}
                    </Button>
                  </MenuItem>  */} 
                </Select>
              )
            }
          </div>

          <div style={{width: "420px"}}>
            <TextField
              autoComplete="off"
              id="descriptionForCharge"
              name="descriptionForCharge"
              className="form-element full-size scroll-to-descriptionForCharge"
              type="text"
              label={this.trans("section/charge-field/description-label") + this.trans("field/optional")}
              value={this.state.descriptionForCharge}
              onChange={this.changeDescriptionForCharge}
              multiline={true}
              rowsMax={10}
              onKeyPress={() => {
                if(!this.state.descriptionForChargeIsManuallyChanged) {
                  this.setState({descriptionForChargeIsManuallyChanged: true});
                }
              }}
              disabled={this.state.isDisabled}
              variant="standard"
              error={!!this.getErrorFor("descriptionForCharge")}
            />
            {!!this.getErrorFor("descriptionForCharge") && <div className="component-error-text">{this.getErrorFor("descriptionForCharge")}</div>}

            {
              (!this.props.charge || (this.props.charge && !this.props.charge?.automaticallyCreated)) && (
                <DatePickerComponent
                  {...this.props}
                  id="dateOfPeriodForCharge"
                  name="dateOfPeriodForCharge"
                  className={"scroll-to-dateOfPeriodForCharge"}
                  label={this.trans("charge-for-period")}
                  initialDate={this.state.dateOfPeriodForCharge}
                  onChange={date => this.selectDate(date, "dateOfPeriodForCharge")}
                  clearButton={true}
                  openTo={"month"}
                  views={["year", "month"]}
                  disableKeyboard={true}
                  disabled={this.state.isDisabled}
                  error={this.getErrorFor("dateOfPeriodForCharge")}
                  margin="0 0 15px 0"
                />
              )
            }

            <DatePickerComponent
              {...this.props}
              id="firstDateForCharge"
              name="firstDateForCharge"
              className={"scroll-to-firstDateForCharge"}
              label={this.trans("section/charge-field/forperiod-label")}
              initialDate={this.state.firstDateForCharge}
              onChange={date => this.selectDate(date, "firstDateForCharge")}
              clearButton={true}
              openTo={"month"}
              views={["year", "month"]}
              disableKeyboard={true}
              disabled={this.state.isDisabled}
              error={this.getErrorFor("firstDateForCharge")}
              financialStatementId={this.props.charge?.ownerFinancialStatementId}
            />
          </div>
        </div>

        <div style={{position: "relative", marginLeft: "50px"}}>
          {
            <div style={{/*position: "absolute", top: "-20px"*/}}>
              <FormControlLabel
                control={
                  <Switch
                    checked={this.state.isInvoice}
                    onChange={this.handleChangeIsInvoice}
                    color="primary"
                    disabled={this.state.isDisabled}
                  />
                  }
                label={this.trans("page/chargecreate-field/invoiceswitch-label")}
              />
            </div>
          }
          {this.state.isInvoice && this.renderInvoiceFields()}
        </div>
      </div>
    );
  }

  public renderInvoiceFields = () => {
    return (
      <div style={{display: "flex", flexDirection: "column", padding: "21px 20px 0 0", minWidth: "200px"}}>
        <DatePickerComponent
          {...this.props}
          className={"full-size invoice-block scroll-to-invoiceDateForCharge"}
          label={this.trans("section/charge-field/invoicedate-label")}
          initialDate={this.state.invoiceDateForCharge}
          onChange={date => this.selectDate(date, "invoiceDateForCharge")}
          disabled={this.state.isDisabled}
          clearButton={true}
          error={this.getErrorFor("invoiceDateForCharge")}
        />

        <TextField
          autoComplete="off"
          //id="invoiceNumberForCharge"
          className="full-size invoice-block scroll-to-invoiceNumberForCharge"
          type="text"
          label={this.trans("section/charge-field/invoicenumber-label")}
          value={this.state.invoiceNumberForCharge}
          onChange={this.changeInvoiceNumberForCharge}
          variant="standard"
          disabled={this.state.isDisabled}
          error={!!this.getErrorFor("invoiceNumberForCharge") || !!this.getErrorFor("invoiceNumber")}
        />
        {(!!this.getErrorFor("invoiceNumberForCharge") || !!this.getErrorFor("invoiceNumber")) &&  <div className="component-error-text">{this.getErrorFor("invoiceNumberForCharge") || this.getErrorFor("invoiceNumber")}</div>}
        
        {
          this.state.renderChargeType !== TypeContainer.pickIdFromLabel("Payout_receivable") &&
          this.state.renderChargeType !== TypeContainer.pickIdFromLabel("Payout_payable") && (
            <div style={{display: "flex", flexDirection: "column"}}>
              <TextField
                autoComplete="off"
                //id="vatForCharge"
                className="full-size  invoice-block scroll-to-vatForCharge"
                type="text"
                label={this.trans("section/invoice-field/vat-label")}
                value={this.state.vatForCharge}
                onChange={this.changeVatForCharge}
                variant="standard"
                disabled={this.state.isDisabled}
                error={!!this.getErrorFor("vatForCharge")}
              />
              {!!this.getErrorFor("vatForCharge") &&  <div className="component-error-text">{this.getErrorFor("vatForCharge")}</div>}
              
              <TextField
                autoComplete="off"
                className="full-size invoice-block scroll-to-vatPercentageForCharge"
                type="text"
                label={this.trans("section/invoice-field/vatpercentage-label")}
                value={this.state.vatPercentageForCharge}
                onChange={this.changeVatPercentageForCharge}
                variant="standard"
                disabled={this.state.isDisabled}
                error={!!this.getErrorFor("vatPercentageForCharge")}
              />
              {!!this.getErrorFor("vatPercentageForCharge") && <div className="component-error-text">{this.getErrorFor("vatPercentageForCharge")}</div>}
            </div>
          )
        }

        {
          (this.state.renderChargeType === TypeContainer.pickIdFromLabel("Payout_receivable") ||
          this.state.renderChargeType === TypeContainer.pickIdFromLabel("Payout_payable")) && 
          this.state.charge?.collectiveVat?.map(vat => {
            return (
              <div style={{display: "flex", flexDirection: "column"}}>
                <TextField
                  autoComplete="off"
                  //id="vatForCharge"
                  className="full-size invoice-block scroll-to-vatForCharge"
                  type="text"
                  label={this.trans("section/invoice-field/vat-label")}
                  value={this.formatter.formatNumber(vat.totalVatAmount)}
                  // onChange={this.changeVatForCharge}
                  variant="standard"
                  disabled={this.state.isDisabled}
                  error={!!this.getErrorFor("vatForCharge")}
                />
                {!!this.getErrorFor("vatForCharge") &&  <div className="component-error-text">{this.getErrorFor("vatForCharge")}</div>}
                
                <TextField
                  autoComplete="off"
                  className="full-size invoice-block  scroll-to-vatPercentageForCharge"
                  type="text"
                  label={this.trans("section/invoice-field/vatpercentage-label")}
                  value={vat.percentage}
                  // onChange={this.changeVatPercentageForCharge}
                  variant="standard"
                  disabled={this.state.isDisabled}
                  error={!!this.getErrorFor("vatPercentageForCharge")}
                />
                {!!this.getErrorFor("vatPercentageForCharge") && <div className="component-error-text">{this.getErrorFor("vatPercentageForCharge")}</div>}
              </div>
            );
          })
        }
      </div>
    );
  }

  public render() {
    let labelText;

    if (this.props.pageName) {
      if (this.props.withoutTabs){
        labelText = this.trans(`page/${this.props.pageName}-section/charge-field/object-label`)
      } else {
        labelText = this.trans(`page/${this.props.pageName}-section/charge-tab/newcharge-field/object-label`)
      }
    }


    return (
      <div style={{position: "relative"}}>
        {
          this.props.showEditIcon && (
            <div 
              className="icon icon-ic-edit small-20px" 
              style={{
                position: "absolute", 
                top: "-10px",
                left: "420px", 
                cursor: "pointer"
              }} 
              onClick={() => this.redirect(`/app/charge/update/${this.props.charge?.id}`)}
            ></div>
          )
        }

        {this.renderCharge(this.state.chargeClassId, labelText)}

        <PromptDialog
          {...this.props}
          title={this.trans("dialog/chargetype-title")}
          content={
            <ChargeTypeCreate
              {...this.props}
              onSaveType={this.addChargeType}
              onCancelType={this.closeChargeTypeCreateDialog}
              chargeTypeSelectField={Number(this.state.chargeClassId) == ChargeClassContainer.pickIdFromLabel("Payable") ? "Payable" : "Receivable"}
            />
          }
          openLeavePrompt={this.state.isCreateChargeTypePopupOpen}
          withoutDefaultDilaogButtons={true}
          onClose={this.closeChargeTypeCreateDialog}
        />

        <CoachNewCounterpartyDialog
          {...this.props}
          openCoachCreateNewCounterparty={this.state.openCoachCreateNewCounterparty}
          onCloseCounterpartyCoach={entity => {
            if(entity) {
              this.setState({
                openCoachCreateNewCounterparty: false            
              }, () => {this.selectCounterpartyForCharge(entity)})
            } else {
              this.setState({
                openCoachCreateNewCounterparty: false  
              })          
            }
          }}
        />
      </div>
    );
  }
}
